(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complementary-products-slider"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(compSection);

    fetch(compSection.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const updated = html.querySelector('.complementary-products-section');
        if (updated && updated.innerHTML.trim().length) {
          compSection.innerHTML = updated.innerHTML;
        }
      })
      .catch(e => console.error(e));
  };

  const compSection = document.querySelector('.complementary-products-section');
  if (compSection) {
    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(compSection);
  }

  } catch(e) { console.error(e); }
})();
})();
